import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/notices', { params })
}

export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/notices/${id}`, { params })
}

/**
 *
 * @param params
 */
export const store = (params = {}): AxiosPromise => {
  return axios.post('/notices', params)
}

/**
 *
 * @param id
 * @param params
 */
export const update = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/notices/${id}`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/notices/${id}/attribute`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/notices/${id}`)
}
